export default {
    path: '/page/chart',
    name: '/chart',
    component: () => import('@/layouts/BaseLayout'),
    redirect: '/chart/task',
    children: [
        {
            path: 'task',
            meta: { title: '报告生成', },
            component: () => import('@/views/chart/task'),
        },
        {
            path: 'report',
            meta: { title: '报告列表',  },
            component: () => import('@/views/chart/report'),
        }
    ],
}
